/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomTooltip from '../../../../../components/CustomTooltip';
import { EmailSubsectionChip } from '../../../../../components/buttons/IconButtons';
import RowCardText from '../../../../../components/RowCardText';
import { EMPTY_VALUES } from '../../../../../Apis/functions';

const VehicleFieldsResume = ({ vehicle }) => {
    const { t } = useTranslation();

    return (<>
        <div className='d-flex flex-column align-items-center mb-4'>
            <CustomTooltip
                text={`${vehicle?.brand} ${vehicle?.subBrand} - ${vehicle?.plate}`}
                classes={`ibl-h3 ibl-font-w-600`}
                showIfTruncated={true}
                tooltipClasses={'p-0'}
            />
        </div>
        <div className='border-bottom-shades-300 mb-3 ' />

        <div className='d-flex align-items-center my-2'>
            <EmailSubsectionChip className='w-20px h-20px' />
            <RowCardText
                className='my-2 ml-3 d-flex justify-content-between overflow-hidden'
                classNameValue='fs-14px ibl-font-w-300 '
                classNameTitle='fs-14px ibl-font-w-600 '
                title={t('model')}
                value={
                    <CustomTooltip
                        text={vehicle?.model || EMPTY_VALUES.DEFAULT}
                        placement='bottom'
                        classes='text-truncate'
                    >
                        <span className='text-truncate d-inline-block'>
                            {vehicle?.model || EMPTY_VALUES.DEFAULT}
                        </span>
                    </CustomTooltip>
                }
            />
        </div>

        <div className='d-flex align-items-center my-2'>
            <EmailSubsectionChip className='w-20px h-20px' />
            <RowCardText
                className='my-2 ml-3 d-flex justify-content-between overflow-hidden'
                classNameValue='fs-14px ibl-font-w-300 '
                classNameTitle='fs-14px ibl-font-w-600 '
                title={t('color')}
                value={
                    <CustomTooltip
                        text={vehicle?.color || EMPTY_VALUES.DEFAULT}
                        placement='bottom'
                        classes='text-truncate'
                    >
                        <span className='text-truncate d-inline-block'>
                            {vehicle?.color || EMPTY_VALUES.DEFAULT}
                        </span>
                    </CustomTooltip>
                }
            />
        </div>

        <div className='d-flex align-items-center my-2'>
            <EmailSubsectionChip className='w-20px h-20px' />
            <RowCardText
                className='my-2 ml-3 d-flex justify-content-between overflow-hidden'
                classNameValue='fs-14px ibl-font-w-300 '
                classNameTitle='fs-14px ibl-font-w-600 '
                title={t('plate')}
                value={
                    <CustomTooltip
                        text={vehicle?.plate || EMPTY_VALUES.DEFAULT}
                        placement='bottom'
                        classes='text-truncate'
                    >
                        <span className='text-truncate d-inline-block'>
                            {vehicle?.plate || EMPTY_VALUES.DEFAULT}
                        </span>
                    </CustomTooltip>
                }
            />
        </div>

        <div className='d-flex align-items-center my-2'>
            <EmailSubsectionChip className='w-20px h-20px' />
            <RowCardText
                className='my-2 ml-3 d-flex justify-content-between overflow-hidden'
                classNameValue='fs-14px ibl-font-w-300 '
                classNameTitle='fs-14px ibl-font-w-600 '
                title={t('vin')}
                value={
                    <CustomTooltip
                        text={vehicle?.vin || EMPTY_VALUES.DEFAULT}
                        placement='bottom'
                        classes='text-truncate'
                    >
                        <span className='text-truncate d-inline-block'>
                            {vehicle?.vin || EMPTY_VALUES.DEFAULT}
                        </span>
                    </CustomTooltip>
                }
            />
        </div>

        <div className='d-flex align-items-center my-2'>
            <EmailSubsectionChip className='w-20px h-20px' />
            <RowCardText
                className='my-2 ml-3 d-flex justify-content-between overflow-hidden'
                classNameValue='fs-14px ibl-font-w-300 '
                classNameTitle='fs-14px ibl-font-w-600 '
                title={t('serial_number')}
                value={
                    <CustomTooltip
                        text={vehicle?.serialNumber || EMPTY_VALUES.DEFAULT}
                        placement='bottom'
                        classes='text-truncate'
                    >
                        <span className='text-truncate d-inline-block'>
                            {vehicle?.serialNumber || EMPTY_VALUES.DEFAULT}
                        </span>
                    </CustomTooltip>
                }
            />
        </div>
    </>);
}

export default VehicleFieldsResume;
